export const config = {
  backend: {
    url: process.env.REACT_APP_BACKEND_URL || 'http://localhost:5050',
    port: process.env.REACT_APP_BACKEND_PORT || '5050',
  },
  vision: {
    url: process.env.REACT_APP_VISION_URL || 'http://localhost:5050',
  },
} as const;

export const getBackendUrl = () => config.backend.url;
export const getBackendPort = () => config.backend.port;
export const getVisionUrl = () => config.vision.url; 